import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { ICharacter } from '../../../../../../api/types/character'
import { characterQueryKey } from '../../../../../../api/queries'
import { queryCharacter } from '../../../../../../api/queries'
import { fromAxiosError } from '../../../../../../context/GlobalError'
import { ErrorHandler } from '../../../../../../components/ErrorHandler/ErrorHandler'

interface Props {
  character_id: number
  children: (char: ICharacter) => any
}

export const CharacterLoader: React.FC<Props> = ({ character_id, children }) => {
  const {
    isLoading,
    error,
    data: char,
  } = useQuery<ICharacter>(characterQueryKey(character_id), () => queryCharacter(character_id))

  return (
    <>
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        {char && children(char)}
      </ErrorHandler>
    </>
  )
}
